export default __webpack_public_path__ + "static/media/hoverImg2.2efa0c6d.svg";